/* eslint-disable */

import {
    SUPPLIER_CUSTOMERS_UPDATED,
    SUPPLIER_CUSTOMER_REINSTALLATION,
    SUPPLIER_CUSTOMERS_LOAD_RFQ,
    SUPPLIER_CUSTOMERS_PER_PAGE,
    SUPPLIER_CUSTOMERS_FILTER,
    SUPPLIER_CUSTOMERS_ALL_CURRENT_PAGE,
    SUPPLIER_CUSTOMERS_PREFERED_CURRENT_PAGE, SUPPLIER_CUSTOMERS_SHORT_UPDATING,
} from '../../../mutation-types';
import _ from "lodash";

function _buildCachedLists(state) {
    const items = Array.isArray(state.items) ? state.items : [];

    const searchIndexById = {};
    _.forEach(items, (c) => {
        if (!c || c.id == null) return;
        const idx = [
            c.number,
            c.name,
            c.type,
            c.phone,
            c.email,
            c.postcode,
            c.suburb,
            c.state,
        ]
            .filter(Boolean)
            .join(' ')
            .toString()
            .toLowerCase();
        searchIndexById[String(c.id)] = idx;
    });
    state.searchIndexById = searchIndexById;

    const byName = (cust) => (cust ? (cust.name || '') : '');
    state.fullSorted = _.orderBy(items, [byName], ['asc']);
    state.activeSorted = _.orderBy(_.filter(items, (i) => i && i.isActive), [byName], ['asc']);
    state.cancelledSorted = _.orderBy(_.filter(items, (i) => i && !i.isActive), [byName], ['asc']);
}

export default {
    [SUPPLIER_CUSTOMER_REINSTALLATION](state) {
        state.rfqs = {
            items: [],
            filter: {}
        };
        state.filter = '';
        state.perPage = 100;
        state.customersAllCurrentPage = 1;
        state.customersPreferedCurrentPage = 1;
        state.items = [];
        state.fullSorted = [];
        state.activeSorted = [];
        state.cancelledSorted = [];
        state.searchIndexById = {};
    },
    [SUPPLIER_CUSTOMERS_UPDATED](state, ui) {
        state.items = _.unionBy(ui.data, state.items, 'id');
        _buildCachedLists(state);
    },
    [SUPPLIER_CUSTOMERS_SHORT_UPDATING](state, ui) {
        state.items = _.unionBy(ui.data, [], 'id');
        _buildCachedLists(state);
    },
    [SUPPLIER_CUSTOMERS_LOAD_RFQ](state, ui) {
        state.rfqs.items = ui;
    },
    [SUPPLIER_CUSTOMERS_PER_PAGE](state, ui) {
        state.perPage = ui;
    },
    [SUPPLIER_CUSTOMERS_FILTER](state, ui) {
        state.filter = ui;
    },
    [SUPPLIER_CUSTOMERS_ALL_CURRENT_PAGE](state, ui) {
        state.customersAllCurrentPage = ui;
    },
    [SUPPLIER_CUSTOMERS_PREFERED_CURRENT_PAGE](state, ui) {
        state.customersPreferedCurrentPage = ui;
    },
}
